// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { AjaxMonitor as AjaxPlugin } from "./ajax";
export { ajaxRecord } from "./ajaxRecord";
//# sourceMappingURL=applicationinsights-dependencies-js.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-dependencies-js/dist-esm/applicationinsights-dependencies-js.js
// module id = 233
// module chunks = 42